import * as yup from 'yup';

import { REQUIRED } from '../../forms/errorsText';
import { QUARANTINED } from '../../presenters/CashbackPresenter';

export const validationFields = {
  state: yup.string().required(REQUIRED),
  quarantinedReason: yup.string().when('state', {
    is: QUARANTINED,
    then: yup.string().required('Must enter the reason'),
  }),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = (cashback) => {
  const { state, quarantinedReason } = cashback;
  return {
    state,
    quarantinedReason: quarantinedReason || '',
  };
};
